/* eslint-disable no-void */
import { ThemeProvider, createTheme } from '@material-ui/core'
import { blue, green, orange, red } from '@material-ui/core/colors'
import { createContext, useCallback, useEffect, useMemo } from 'react'
import { RouterProvider } from 'react-router-dom'
import { useImmerReducer } from 'use-immer'
import Websocket from './components/Websocket'
import { getCookie, notificacao, programasUsuarios } from './components/api'
import './global.css'
import { router } from './router'
import { Toaster } from 'sonner'

const DEFAULT_USER_ID = 0
const DEFAULT_USER_NAME = ''
const DEFAULT_USER_MAIL = ''
const DEFAULT_USER_PROGRAM = ''
const DEFAULT_USER_TOKEN = ''
const DEFAULT_USER_PICTURE = ''

export const initialStateUsuarioLogado = {
  id: DEFAULT_USER_ID,
  nome: DEFAULT_USER_NAME,
  email: DEFAULT_USER_MAIL,
  programa: DEFAULT_USER_PROGRAM,
  token: DEFAULT_USER_TOKEN,
  foto: DEFAULT_USER_PICTURE,
}

const initialState = {
  medico: null,
  localAtendimento: null,
  agenda: null,
  menuOpen: false,
  menuWidth: 240,
  usuarioLogado: initialStateUsuarioLogado,
  programas: [],
  notificacoes: [],
  socketReceive: (data) => void data,
  dispatch: ({ type, field, value }) => void (type, field, value),
  verificaLogin: () => 0,
}

export const GlobalContext = createContext(initialState)

const reducer = (state = initialState, { type, field, value }) => {
  switch (type) {
    // case 'lerNotificacao':
    //   state.notificacoes[
    //     state.notificacoes.findIndex((not) => not.idNotificacao === value)
    //   ].dtLeitura = DateTime.now().toFormat('d/MM/y hh:mm')
    // break
    case 'setLocalAtendimento':
      state.localAtendimento = value
      // state.agenda = null
      // window.localStorage.setItem('selectedAgenda', null)
      window.localStorage.setItem(
        'selectedLocalAtendimento',
        value ? JSON.stringify(value) : null,
      )
      break
    case 'setAgenda':
      state.agenda = value
      window.localStorage.setItem(
        'selectedAgenda',
        value ? JSON.stringify(value) : null,
      )
      break
    default:
      if (field) state[field] = value
      break
  }
}

function App() {
  const [state, dispatch] = useImmerReducer(reducer, initialState)
  // const prefersDarkMode = false && useMediaQuery('(prefers-color-scheme: dark)');
  const prefersDarkMode = false

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            light: '#D35400',
            main: '#D35400',
            dark: '#D35400',
          },
          secondary: {
            light: '#A04000',
            main: '#A04000',
            dark: '#A04000',
          },
          error: {
            light: red[300],
            main: red[500],
            dark: red[700],
          },
          warning: {
            light: orange[300],
            main: orange[500],
            dark: orange[700],
          },
          info: {
            light: blue[300],
            main: blue[500],
            dark: blue[700],
          },
          success: {
            light: green[300],
            main: green[500],
            dark: green[700],
          },
          type: prefersDarkMode ? 'dark' : 'light',
        },
      }),
    [prefersDarkMode],
  )

  const storageUser = useCallback(
    (data) => {
      const user = {
        ...initialStateUsuarioLogado,
        id: data?.idUsuario || DEFAULT_USER_ID,
        nome: data?.nome || DEFAULT_USER_NAME,
        email: data?.dsEmail || DEFAULT_USER_TOKEN,
        programa: data?.programa || DEFAULT_USER_PROGRAM,
        token: data?.token || DEFAULT_USER_TOKEN,
        foto: data?.foto || DEFAULT_USER_PICTURE,
      }
      localStorage.setItem('user', JSON.stringify(user))
      dispatch({ field: 'usuarioLogado', value: user })
    },
    [dispatch],
  )

  const getLoggedUser = useCallback(
    (user) => {
      if (user) {
        dispatch({ field: 'usuarioLogado', value: JSON.parse(user) })
      } else {
        return null
      }
    },
    [dispatch],
  )

  const verificaLogin = useCallback(
    async (data, navigate, location) => {
      const localStorageUser = localStorage.getItem('user')
      localStorageUser && getLoggedUser(localStorageUser)
      if (!getCookie('token')) {
        navigate('/login')
        return
      }

      data && storageUser(data)

      const res = await programasUsuarios()
      if (res.status) {
        if (location?.pathname === '/') navigate(res.list?.at(0)?.at(3))
        dispatch({ field: 'programas', value: res.list })
      } else {
        navigate('/login')
      }
    },
    [dispatch, getLoggedUser, storageUser],
  )

  const globalState = useMemo(
    () => ({ ...state, dispatch, verificaLogin }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, dispatch],
  )

  const buscaNotificacoes = async () => {
    const { lista } = await notificacao()
    dispatch({ field: 'notificacoes', value: lista })
  }

  useEffect(() => {
    buscaNotificacoes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <GlobalContext.Provider value={globalState}>
        <Websocket />
        <Toaster richColors />
        <RouterProvider router={router} />
      </GlobalContext.Provider>
    </ThemeProvider>
  )
}

export default App
